import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { QUOTE_URL } from "../environments/environment";
import { ResponseQuote, ResponseQuoteListItem } from "../types/dai-server/quotes/quote-responses";
import { Observable } from "rxjs";
import { PriceType } from "../types/dai-server/quotes/enums";
import { RequestCreateQuickQuote, RequestUpdateQuickQuote, RequestUpdateQuote, RequestUpdateQuoteLineItem } from "../types/dai-server/quotes/quote-requests";

@Injectable({
    providedIn: 'root'
})
export class QuoteService {
    private apiUrl = QUOTE_URL;

    constructor(private http: HttpClient) { }

    createQuickQuote(quote: RequestCreateQuickQuote): Observable<ResponseQuote> {
        return this.http.post<ResponseQuote>(`${this.apiUrl}/quick-quote`, quote);
    }

    getQuotes(): Observable<ResponseQuoteListItem[]> {
        return this.http.get<ResponseQuoteListItem[]>(`${this.apiUrl}`)
    }

    getQuote(id: string): Observable<ResponseQuote> {
        return this.http.get<ResponseQuote>(`${this.apiUrl}/${id}`);
    }

    updateQuickQuote(quoteId: string, quote: RequestUpdateQuickQuote): Observable<ResponseQuote> {
        return this.http.put<ResponseQuote>(`${this.apiUrl}/quick-quote/${quoteId}`, quote);
    }

    updateQuote(quoteId: string, quote: RequestUpdateQuote): Observable<ResponseQuote> {
        return this.http.put<ResponseQuote>(`${this.apiUrl}/${quoteId}`, quote);
    }

    updatePriceType(quoteId: string, priceType: PriceType): Observable<ResponseQuote> {
        // The server expects a bare JSON string; HttpClient would send a raw string as text/plain
        return this.http.put<ResponseQuote>(`${this.apiUrl}/${quoteId}/price-type`, JSON.stringify(priceType), {
            headers: { 'Content-Type': 'application/json' }
        });
    }

    updateQuoteItem(quoteId: string, productId: string, update: RequestUpdateQuoteLineItem): Observable<void> {
        return this.http.post<void>(`${this.apiUrl}/${quoteId}/items/${productId}`, update);
    }

    deleteQuoteItem(quoteId: string, productId: string): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${quoteId}/items/${productId}`);
    }

    downloadQuotePdf(quoteId: string): Observable<Blob> {
        return this.http.get(`${this.apiUrl}/${quoteId}/pdf`, {
            responseType: 'blob'
        });
    }

    updatePriceOverride(quoteId: string, productId: string, value: number): Observable<void> {
        return this.http.post<void>(`${this.apiUrl}/${quoteId}/items/${productId}/price`, value);
    }

    deletePriceOverride(quoteId: string, productId: string): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${quoteId}/items/${productId}/price`);
    }
}